export enum ActionType {
    OPEN = 'open',
    CLOSE = 'close'
}
